"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResponsiveSize = void 0;
/**
 * Get responsive size based on viewport width
 * On mobile devices (< 640px), scales down sizes more aggressively
 *
 * @param defaultSize - The desktop size
 * @param type - Type of dimension ('width' or 'height')
 * @returns Scaled size for current viewport
 */
const getResponsiveSize = (defaultSize, type = "width") => {
    if (typeof window === "undefined")
        return defaultSize;
    const viewportWidth = window.innerWidth;
    // On mobile devices (< 640px), scale down the sizes more aggressively
    if (viewportWidth < 640) {
        // More aggressive scale factor for mobile (0.4 to 0.6)
        const scaleFactor = Math.max(0.4, Math.min(0.6, viewportWidth / 640));
        return Math.round(defaultSize * scaleFactor);
    }
    return defaultSize;
};
exports.getResponsiveSize = getResponsiveSize;
